"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventCreated = exports.isValidUrl = exports.getUserTimezone = exports.getUnescapedName = exports.getPublishData = exports.getEventGroup = exports.getDuplicateData = exports.getDefaultEventState = exports.getDefaultConstructorState = exports.errorMessages = exports.Errors = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _EventDateFormatter = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDateFormatter"));

var _excluded = ["externalRegistrationUrl", "externalRegistrationUrlLabel", "endDate", "timezone", "endTime", "startTime", "startDate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var errorMessages = {
  titleEmpty: 'Please insert a title',
  titleEmptyOld: 'Please add a title',
  startDateEmpty: 'Please provide start date',
  endDateEmpty: 'Please provide start date',
  startTimeEmpty: 'Please provide start time',
  endTimeEmpty: 'Please provide end time',
  endDateBeforeStartDate: 'The end date and time need to be after the start date and time',
  descriptionTooShort: 'Event description is too short',
  titleTooShort: 'Title must contain at least 3 characters',
  timezoneEmpty: 'Please select a time zone',
  registration: 'Select an event type',
  externalRegistrationUrlEmpty: 'Please fill in button URL',
  externalRegistrationUrlNotValid: 'Please fill in valid button URL',
  externalRegistrationUrlLabelEmpty: 'Please fill in button text',
  urlTextEmpty: 'Please fill in Link text',
  urlLinkEmpty: 'Please fill in Link URL',
  urlLinkNotValid: 'Please fill in valid Link URL'
};
exports.errorMessages = errorMessages;

var Errors = /*#__PURE__*/function () {
  function Errors() {
    (0, _classCallCheck2.default)(this, Errors);
    (0, _defineProperty2.default)(this, "errors", void 0);
    this.errors = new Map();
  }

  (0, _createClass2.default)(Errors, [{
    key: "isEmpty",
    value: function isEmpty() {
      return this.errors.size === 0;
    }
  }, {
    key: "addError",
    value: function addError(field, error) {
      this.errors.set(field, error);
      return this;
    }
  }, {
    key: "clearError",
    value: function clearError(field) {
      this.errors.delete(field);
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.errors.clear();
      return this;
    }
  }, {
    key: "getError",
    value: function getError(field) {
      var _this$errors$get;

      return (_this$errors$get = this.errors.get(field)) !== null && _this$errors$get !== void 0 ? _this$errors$get : '';
    }
  }, {
    key: "containsOneOf",
    value: function containsOneOf(fields) {
      var _this = this;

      return fields.some(function (field) {
        return !!_this.getError(field);
      });
    }
  }, {
    key: "getErrorsCount",
    value: function getErrorsCount() {
      return this.errors.size;
    }
  }]);
  return Errors;
}();

exports.Errors = Errors;

var getEventGroup = function getEventGroup(userGroupId, groups) {
  return groups.filter(function (group) {
    return group.id === +userGroupId;
  });
};

exports.getEventGroup = getEventGroup;

var getDefaultConstructorState = function getDefaultConstructorState(userGroupId, groups) {
  var _getEventGroup = getEventGroup(userGroupId, groups),
      _getEventGroup2 = (0, _slicedToArray2.default)(_getEventGroup, 1),
      eventGroup = _getEventGroup2[0];

  return {
    startTime: {},
    endTime: {},
    isLoading: false,
    hasUnsavedChanges: false,
    showDeletedConfirmationModal: false,
    enableGroupsPicker: false,
    showPublishedModal: false,
    errors: new Errors(),
    group: eventGroup,
    backendResponse: {
      messageType: null,
      messageText: ''
    },
    destinationUrl: ''
  };
};

exports.getDefaultConstructorState = getDefaultConstructorState;

var getUserTimezone = function getUserTimezone(timezoneList) {
  var browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var userTimezone = timezoneList.find(function (tz) {
    return tz.value === browserTimezone;
  });
  return userTimezone !== null && userTimezone !== void 0 ? userTimezone : {
    title: '',
    value: ''
  };
};

exports.getUserTimezone = getUserTimezone;

var getDefaultEventState = function getDefaultEventState(timezoneList) {
  return {
    endDate: '',
    startDate: '',
    eventId: 0,
    featuredImage: '',
    type: '',
    title: '',
    location: '',
    url: '',
    urlLabel: '',
    externalRegistrationUrl: '',
    externalRegistrationUrlLabel: '',
    description: '',
    userGroupId: 0,
    open: true,
    timezone: getUserTimezone(timezoneList),
    featuredTopics: [],
    confirmationMessage: '',
    status: 'new'
  };
};

exports.getDefaultEventState = getDefaultEventState;

var trackEventCreated = function trackEventCreated(res, title, type) {
  var eventModerationPage = res.headers.location;

  if (eventModerationPage) {
    var _getInsidedData = (0, _insidedDataStorage.getInsidedData)('user'),
        userid = _getInsidedData.userid,
        name = _getInsidedData.name,
        role = _getInsidedData.role;

    var communityUrl = (0, _globals.default)('communityUrl');
    var eventId = res.data.id;
    var eventDestinationUrl = communityUrl.concat('/events/', eventId);

    _publish.default.trackEvent('userevent', {
      type: 'Event Created',
      community_id: (0, _globals.default)('communityId'),
      destination_event_url: eventDestinationUrl,
      author_id: userid,
      author_role: role,
      author_name: name,
      event_id: eventId,
      event_title: title,
      event_type: type
    });
  }
};

exports.trackEventCreated = trackEventCreated;

var getUnescapedName = function getUnescapedName(name) {
  return name.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#39;/g, "'").replace(/&quot;/g, '"');
};

exports.getUnescapedName = getUnescapedName;

var getDuplicateData = function getDuplicateData(_ref) {
  var _ref2, _group$id;

  var url = _ref.url,
      urlLabel = _ref.urlLabel,
      featuredImage = _ref.featuredImage,
      eventId = _ref.eventId,
      location = _ref.location,
      title = _ref.title,
      type = _ref.type,
      featuredTopics = _ref.featuredTopics,
      description = _ref.description,
      confirmationMessage = _ref.confirmationMessage,
      group = _ref.group,
      status = _ref.status,
      userGroupId = _ref.userGroupId;
  return {
    eventId: eventId,
    featuredImage: featuredImage,
    type: type,
    title: title,
    location: location,
    url: url,
    urlLabel: urlLabel,
    description: description,
    featuredTopics: featuredTopics,
    confirmationMessage: confirmationMessage,
    group: (_ref2 = (_group$id = group === null || group === void 0 ? void 0 : group.id) !== null && _group$id !== void 0 ? _group$id : userGroupId) !== null && _ref2 !== void 0 ? _ref2 : '',
    status: status,
    timezone: '',
    startDate: '',
    endDate: '',
    externalRegistrationUrl: '',
    externalRegistrationUrlLabel: ''
  };
};

exports.getDuplicateData = getDuplicateData;

var getPublishData = function getPublishData(_ref3) {
  var externalRegistrationUrl = _ref3.externalRegistrationUrl,
      externalRegistrationUrlLabel = _ref3.externalRegistrationUrlLabel,
      endDate = _ref3.endDate,
      timezone = _ref3.timezone,
      endTime = _ref3.endTime,
      startTime = _ref3.startTime,
      startDate = _ref3.startDate,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _objectSpread(_objectSpread({}, getDuplicateData(_objectSpread({}, rest))), {}, {
    timezone: timezone === null || timezone === void 0 ? void 0 : timezone.value,
    startDate: _EventDateFormatter.default.getFullUtcDate(startDate, startTime, timezone),
    endDate: _EventDateFormatter.default.getFullUtcDate(endDate, endTime, timezone),
    externalRegistrationUrl: externalRegistrationUrl,
    externalRegistrationUrlLabel: externalRegistrationUrlLabel
  });
};

exports.getPublishData = getPublishData;

var isValidUrl = function isValidUrl(url) {
  try {
    var newUrl = new URL(url);
    return !!newUrl;
  } catch (_unused) {
    return false;
  }
};

exports.isValidUrl = isValidUrl;